import React, { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useLanguage } from '../../context/LanguageContext';

export const AccountLink = ({ masked, onSave }) => {
  const { t } = useLanguage();
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (value.trim().length < 4) return;
    setSaving(true);
    await onSave(value.trim());
    setSaving(false);
    setValue('');
  };

  return (
    <form onSubmit={submit} className="rounded-2xl border border-primary/30 bg-primary/5 p-4 space-y-3" data-testid="utt-account-form">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <Lock className="h-4 w-4 text-primary" />
        {t('Link your UTT AMIS account number', 'Unganisha namba ya akaunti yako ya UTT AMIS')}
      </div>
      <p className="text-xs text-muted-foreground">
        {masked
          ? t(`Linked: ${masked}. Enter a new number to replace it.`, `Imeunganishwa: ${masked}. Weka namba mpya kuibadilisha.`)
          : t('Shown on the final “Congratulations” screen. Stored encrypted — CORE Securities uses it to allocate your units.',
              'Inaonekana kwenye ujumbe wa mwisho wa Hongera. Inahifadhiwa kwa usimbaji fiche — CORE Securities huitumia kugawa vipande vyako.')}
      </p>
      <div className="flex gap-2">
        <Input value={value} onChange={(e) => setValue(e.target.value)} placeholder={t('e.g. 1234567', 'mfano 1234567')} maxLength={24} data-testid="utt-account-input" />
        <Button type="submit" disabled={saving || value.trim().length < 4} data-testid="utt-account-save">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : t('Save', 'Hifadhi')}
        </Button>
      </div>
    </form>
  );
};
